

export function newProject_getFormFieldsProto(formComponent: any) {


    const onSelectColor = (color:number) => {
        formComponent.setState({colorSelectedManually: true})
    }


    return {
        color: {
            type            : 'select',
            isRequired      : true,
            label           : 'Color',
            onUserChange    : onSelectColor
        },

        company: {
            type        : 'select',
            isRequired  : true,
            label       : 'Company',
        },

        parentProject: {
            type: 'select',
            isRequired: !gd.user.acl.canCreateRootProject,
            onUserChange: formComponent.onParentChange,
            label: 'Parent project'
        },

        name: {
            type        : 'input',
            isRequired  : true
        },

        owner: {
            type: 'select',
            isRequired: false,
            label: 'Project owner'
        },

        defaultView: {
            type: 'select',
            isRequired: false,
            label: 'Default view'
        },

        copyOptions: {
            type: 'select',
            isRequired: false,
        },

    }


}